import { useQuery } from 'react-query';

import { comments_summary_api_article_path } from '@routes';
import request from '@utils/backend-api/request';

export const ARTICLE_COMMENTS_SUMMARY_KEY = 'ARTICLE_COMMENTS_SUMMARY';

export function useArticleCommentsSummary(articleId: number) {
  const { data } = useQuery(
    [ARTICLE_COMMENTS_SUMMARY_KEY, articleId],
    async () => {
      return await request('get', comments_summary_api_article_path({ id: articleId }));
    },
    {
      retry: (failureCount, error) =>
        (error as { error?: string })?.error !== 'Not authorized' && failureCount < 3,
    }
  );

  return {
    commentsCount: (data?.commentsCount as number) ?? 0,
    commenters: (data?.commenters as string[]) ?? [],
  };
}
